import React from 'react';
import { FileText, Shield } from 'lucide-react';
export function Footer({
  onNavigate
}: {
  onNavigate: (page: 'terms' | 'privacy') => void;
}) {
  return <footer className="bg-navy-900 py-12 px-4 border-t border-navy-800" data-id="element-59">
      <div className="max-w-4xl mx-auto text-center" data-id="element-60">
        <p className="text-gray-500 text-sm" data-id="element-61">
          © {new Date().getFullYear()} CPAP Compliance Rescue. All rights
          reserved.
        </p>
        <p className="mt-2 text-gray-600 text-sm" data-id="element-62">
          Disclaimer: This guide is for educational purposes only and does not
          constitute medical advice.
        </p>

        <div className="mt-6 flex items-center justify-center gap-6" data-id="element-63">
          <button onClick={() => onNavigate('terms')} className="inline-flex items-center gap-1.5 text-gray-400 hover:text-teal-400 transition-colors text-sm font-medium" data-id="element-64">
            <FileText className="h-3.5 w-3.5" data-id="element-65" />
            Terms of Service
          </button>

          <span className="text-navy-700" data-id="element-66">|</span>

          <button onClick={() => onNavigate('privacy')} className="inline-flex items-center gap-1.5 text-gray-400 hover:text-teal-400 transition-colors text-sm font-medium" data-id="element-67">
            <Shield className="h-3.5 w-3.5" data-id="element-68" />
            Privacy Policy
          </button>
        </div>
      </div>
    </footer>;
}